import React from "react";
import { ExternalLink, ShieldCheck } from "lucide-react";

const DocumentEvidenceList = ({ documents = [] }) => {
  if (!documents.length) {
    return <p className="text-sm text-slate-500">No documents attached yet.</p>;
  }

  return (
    <div className="space-y-3">
      {documents.map((document) => {
        const extracted = document.extracted_data || {};
        return (
          <div key={document.id} className="rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className="font-semibold text-slate-800">
                {document.document_type?.replaceAll("_", " ") || "Supplier Certificate"}
              </span>
              {document.is_verified && (
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700">
                  <ShieldCheck className="h-4 w-4" /> Xtract Verified
                </span>
              )}
            </div>
            {document.reference_number && <p className="mt-1 text-slate-700">{document.reference_number}</p>}
            {document.document_type === "vendor_completion_report" ? (
              <div className="mt-3 space-y-2 text-xs text-slate-600">
                <div className="grid gap-2 sm:grid-cols-2">
                  {extracted.report_number && <p><span className="font-semibold text-slate-700">Report:</span> {extracted.report_number}</p>}
                  {extracted.completion_date && <p><span className="font-semibold text-slate-700">Completed:</span> {extracted.completion_date}</p>}
                  {extracted.service_vendor && <p><span className="font-semibold text-slate-700">Vendor:</span> {extracted.service_vendor}</p>}
                  {extracted.equipment && <p><span className="font-semibold text-slate-700">Equipment:</span> {extracted.equipment}</p>}
                  {extracted.reported_issue && <p className="sm:col-span-2"><span className="font-semibold text-slate-700">Reported issue:</span> {extracted.reported_issue}</p>}
                  {extracted.part_number && <p><span className="font-semibold text-slate-700">Part:</span> {extracted.part_number}</p>}
                  {extracted.installed_serial_number && <p><span className="font-semibold text-slate-700">Installed serial:</span> {extracted.installed_serial_number}</p>}
                  {extracted.functional_test_result && <p><span className="font-semibold text-slate-700">Functional test:</span> {extracted.functional_test_result}</p>}
                  {extracted.equipment_status && <p><span className="font-semibold text-slate-700">Equipment status:</span> {extracted.equipment_status}</p>}
                </div>
                {extracted.completion_remarks && <p><span className="font-semibold text-slate-700">Remarks:</span> {extracted.completion_remarks}</p>}
                {Array.isArray(extracted.functional_verification) && extracted.functional_verification.length > 0 && (
                  <div>
                    <p className="font-semibold text-slate-700">Functional verification</p>
                    <ul className="list-disc space-y-1 pl-4">
                      {extracted.functional_verification.map((item, index) => (
                        <li key={index}>{typeof item === "string" ? item : item.test || item.result || item.description || JSON.stringify(item)}</li>
                      ))}
                    </ul>
                  </div>
                )}
                {Array.isArray(extracted.work_performed) && extracted.work_performed.length > 0 && (
                  <div>
                    <p className="font-semibold text-slate-700">Work performed</p>
                    <ul className="list-disc space-y-1 pl-4">
                      {extracted.work_performed.map((item, index) => (
                        <li key={index}>{typeof item === "string" ? item : item.description || item.activity || JSON.stringify(item)}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ) : (
              (extracted.serial_number || extracted.inspection_result || extracted.deviation_status) && (
                <p className="mt-2 text-xs text-slate-500">
                  {extracted.serial_number && `Part Serial: ${extracted.serial_number}`}
                  {extracted.inspection_result && ` | Inspection: ${extracted.inspection_result}`}
                  {extracted.deviation_status && ` | Deviation: ${extracted.deviation_status}`}
                </p>
              )
            )}
            {document.file_storage_path && (
              <a
                href={`/api/document-evidence/${document.id}/file`}
                target="_blank"
                rel="noreferrer"
                className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-blue-600 hover:text-blue-800"
              >
                View document <ExternalLink className="h-3.5 w-3.5" />
              </a>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DocumentEvidenceList;
